export default __webpack_public_path__ + "static/media/txt_title.8d536d46.svg";